export const WISHLISTS_DATA = 'wishlists-data';
export const WISHLIST_ITEMS_CACHE = 'wishlistPageItems';
export const WISHLIST_PAGE_METADATA = 'WISHLIST_PAGE_METADATA';

export const WISHLIST_QUERY_CACHES = [WISHLISTS_DATA, WISHLIST_ITEMS_CACHE, WISHLIST_PAGE_METADATA];
